export const OnboardingSteps = {
    goals: 'goals',
    howTo: 'how_to',
    installation: 'installation',
    finish: 'finish'
};
